// Components
import { ContractErrorComponent } from '../components/error/contract-error.component';
import { IconPositionType, VARIANTS } from '@openbank/ziniaweb-ui-components';
// Enumerations
import { ContractStatesEnumeration } from '../enumerations/contract-states.enumeration';
// Resolvers
import { getContractFlowDataResolver } from '../resolvers/contract.resolver';
// Translations
import {
  AT_THE_TIME_OF_SHIPPING,
  CONTRACT_DESCRIPTIONS,
  CONTRACT_TITLES,
  EVERY_MONTH,
  INTEREST,
  PAYMENT_METHOD,
  TOTAL_AMOUNT,
  TOTAL_BASKET_AMOUNT,
} from '../translations/contract.translations';
import { FinancialDataType } from '../components/financial-data/types/financial-data.component.type';

const CONTRACT_LAYOUT_COMPONENT_PROPS = {
    externalFetchingConfiguration: {
      description: CONTRACT_DESCRIPTIONS.PRECONTRACTUAL,
      title: CONTRACT_TITLES.PRECONTRACTUAL,
    },
    errorComponent: ContractErrorComponent,
    fetchResolver: getContractFlowDataResolver,
  },
  CONTRACT_LAYOUT_ASSET_COMPONENT_PROPS = {
    [ContractStatesEnumeration.OTP]: 'illustration_L3_security_otp-mobile-default',
  };

const DOWNLOAD_LINK_PROPS = {
  iconConfiguration: {
    icon: 'icon_arrow_download',
    height: '20px',
    width: '20px',
  },
  iconPosition: IconPositionType.LEFT,
  type: VARIANTS.ButtonVariantType.PRIMARY_GHOST,
  size: VARIANTS.ButtonSizeType.ICON_SMALL,
  underline: true,
};

const FINANCIAL_LIST_PROPS = [
  {
    label: TOTAL_BASKET_AMOUNT,
    value: 0,
    currency: 'eur',
  },
  {
    label: INTEREST,
    value: 0,
    currency: 'eur',
    nominalInterest: 0,
    interestRate: 0,
  },
  {
    label: TOTAL_AMOUNT,
    value: 0,
    currency: 'eur',
  },
  {
    label: AT_THE_TIME_OF_SHIPPING,
    value: 0,
    currency: 'eur',
  },
  {
    label: EVERY_MONTH,
    value: 0,
    currency: 'eur',
    installments: 0,
  },
  {
    label: PAYMENT_METHOD,
    value: 'XXXX',
  },
] as unknown as FinancialDataType[];

const PDF_VIEWER_PROPS = {
  variant: VARIANTS.PDFViewerVariantType.DEFAULT,
  pdfScale: 1,
  scrollDownButton: {
    icon: { icon: 'icon_chevron_down', altText: 'Scroll to bottom' },
  },
  dataTestId: 'pdfViewerTestId',
};

const AMOUNT = 0,
  INTERESTS = 1,
  TOTAL = 2,
  SHIPPING = 3,
  MONTHLY = 4,
  PAYMENT = 5;

export {
  AMOUNT,
  CONTRACT_LAYOUT_ASSET_COMPONENT_PROPS,
  CONTRACT_LAYOUT_COMPONENT_PROPS,
  DOWNLOAD_LINK_PROPS,
  FINANCIAL_LIST_PROPS,
  INTERESTS,
  MONTHLY,
  PAYMENT,
  PDF_VIEWER_PROPS,
  SHIPPING,
  TOTAL,
};
